import {
  Button,
  IconButton,
  Stack,
  SxProps,
  Theme,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";

import { RouteType } from "../../router";

interface HeaderIconButtonProps {
  route: RouteType;
  tooltip: string;
  icon: React.ReactNode;
  disabled?: boolean;
  showLabel?: boolean;
  buttonRef?: (element: HTMLAnchorElement | null) => void;
  onHoverStart?: (route: RouteType) => void;
  onHoverEnd?: () => void;
  sx?: SxProps<Theme>;
}

const HeaderIconButton: React.FC<HeaderIconButtonProps> = ({
  route,
  tooltip,
  icon,
  disabled,
  showLabel = false,
  buttonRef,
  onHoverStart,
  onHoverEnd,
  sx,
}) => {
  if (showLabel) {
    return (
      <Button
        ref={buttonRef}
        component={Link}
        to={route}
        disabled={disabled}
        startIcon={icon}
        onMouseEnter={() => onHoverStart?.(route)}
        onMouseLeave={onHoverEnd}
        sx={{
          minWidth: "fit-content",
          color: "#272827",
          height: "100%",
          alignSelf: "stretch",
          borderRadius: 0,
          px: 3,
          py: 0,
          textTransform: "none",
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "transparent",
          },
          ...sx,
        }}
      >
        {tooltip}
      </Button>
    );
  }

  return (
    <Tooltip title={tooltip}>
      <Stack
        height={"fit-content"}
        width={"fit-content"}
        justifyItems={"center"}
        alignContent={"center"}
        spacing={0}
      >
        <IconButton
          component={Link}
          to={route}
          disabled={disabled}
          sx={sx}
        >
          <Stack spacing={0}>{icon}</Stack>
        </IconButton>
      </Stack>
    </Tooltip>
  );
};

export default HeaderIconButton;
